import Modal from 'components/Luxkit/Modal/Modal'
import BodyTextBlock from 'components/Luxkit/TextBlocks/BodyTextBlock'
import React from 'react'

function RemainingHoursModal() {
  return (
    <Modal title="Cancellation protection">
      <BodyTextBlock variant="medium">
        You have 24 hours after booking to add cancellation protection. After that, it’s no longer available—this limit is set by our partner, XCover.
      </BodyTextBlock>
    </Modal>
  )
}

export default RemainingHoursModal
